/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { Button } from 'ui-v2/components/Button';
import { Typography } from 'ui-v2/components/Typography';
import Modal from 'ui-v2/components/Modal';
import s from './UpdateDetails.module.scss';
import WarningSVG from "../../icons/warning.svg"

type UpdateDetailsProps = {
  isShow: boolean;
  onClose: () => void;
  onDone: () => void;
  zIndex?: number
};

export const UpdateDetails = ({
  isShow,
  onClose,
  onDone,
  zIndex = 105
}: UpdateDetailsProps) => (
  <Modal
    show={isShow}
    head={{ show: true, title: '', onClose: onClose }}
    closeOnClickOutside={false}
    noPadding
    animation={{ type: 'btt', timeout: 's' }}
    rootStyle={{
      zIndex,
    }}
  >
    <div className={s.root}>
      <div className={s.upper}>
        <div className={s.image_container}>
          <WarningSVG />
        </div>
        <div className={s.text_container}>
          <div className={s.title}>
            <Typography
              variant="h_3_bold"
              label="Oops! Seems like your address details are incomplete"
              style={{ marginTop: "10px" }}
            />
          </div>
          <div className={s.sub_title}>
            <Typography
              variant="body_2_regular"
              color="secondary"
              label="Please update the missing details now and help us serve you better"
            />
          </div>
        </div>
      </div>

      <div className={s.button_container}>
        <Button size='medium'  variant="primary" label="Update now" onClick={onDone} />
      </div>
    </div>
  </Modal>
);
